import { Currency } from 'common/contracts';

import { DisplayPrices, Order } from './types';
import Decimal from 'decimal.js';

const USD_MULTIPLIER = 100;

export const calculateDisplayPrices = (
  order: Order,
  currencyCodeToCurrencyMap: Map<string, Currency>
): DisplayPrices => {
  const currency = currencyCodeToCurrencyMap.get(order.currency);
  const multiplier = currency?.multiplier || 1;
  const fractionDigits = Math.log10(multiplier);

  const totalPayment = new Decimal(order.amountNetTotal)
    .add(new Decimal(order.taxTotal))
    .toNumber();

  return {
    bundlePrice: (order.bundlePrice / multiplier).toFixed(fractionDigits),
    amountNetTotal: (order.amountNetTotal / multiplier).toFixed(fractionDigits),
    taxTotal: (order.taxTotal / multiplier).toFixed(fractionDigits),
    currencyExchangeCost: (order.currencyExchangeCost / USD_MULTIPLIER).toFixed(
      2
    ),
    estimatedAppchargeFee:
      order.estimatedAppchargeFee != null
        ? (order.estimatedAppchargeFee / USD_MULTIPLIER).toFixed(2)
        : undefined,
    estimatedPublisherNetAmount:
      order.estimatedPublisherNetAmount != null
        ? (order.estimatedPublisherNetAmount / USD_MULTIPLIER).toFixed(2)
        : undefined,
    discountAmount: Math.abs(order.discountAmount / multiplier).toFixed(
      fractionDigits
    ),
    amountNetInDollar: (order.amountNetInDollar / USD_MULTIPLIER).toFixed(2),
    totalPrice: Math.abs(order.offerSnapshot.price / multiplier).toFixed(
      fractionDigits
    ),
    taxAmountInDollar: Math.abs(
      order.taxAmountInDollar / USD_MULTIPLIER
    ).toFixed(2),
    totalPayment: (totalPayment / multiplier).toFixed(fractionDigits)
  };
};
